export const getCurrentModuleQuestionNumber = ({
  moduleQuestions,
  moduleCurrentIndexId,
}) =>
  moduleQuestions.findIndex(
    (question) => question.id === moduleCurrentIndexId,
  ) + 1;
